import axios from 'axios';
import store from 'redux/configureStore';
import { logout } from 'redux/modules/auth/action';
//import moment from 'moment';
//import momentTZ from 'moment-timezone';

axios.interceptors.request.use(
    config => {
        /*let localStorage = loadState();
        let auth = null;
        if(localStorage) {
            auth = localStorage.auth;
        }*/
        //const auth = loadState().auth;
        const auth = store.getState().auth;
        if (config.url === 'http://localhost:3000/server/') return config;
        if (config.method !== 'get') {
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        }
        if (auth && auth.isAuthenticated) {
            //console.log('localStorage Token from interceptor: ', JSON.parse(window.localStorage.state).auth.wsseToken.accessToken);
            //console.log('Token from interceptor: ', auth.wsseToken.accessToken);
            //config.headers['X-AUTH-TOKEN'] = loadState().auth.wsseToken.accessToken;
            //config.headers['X-AUTH-TOKEN'] = JSON.parse(window.localStorage.state).auth.wsseToken.accessToken;
            config.headers['X-AUTH-TOKEN'] = auth.wsseToken.accessToken;
        }
        return config;
    },
    error => {
        //console.log('http client error: ', error)
    }
);

axios.interceptors.response.use(
    function(response) {
        return response;
    },
    function(error) {
        if (error.response.statusCode === 423) {
            const auth = store.getState().auth;
            if (auth && auth.isAuthenticated) {
                store.dispatch(logout());
                console.log('interceptor logout, bip bip');
            }
        }
        // this is the possible rework of refresh token
        /*const originalRequest = error.config;

        if (error.response.status === 403 && originalRequest.url.includes('/api/v1/profile/refresh_token')) {
            //router.push('/login');
            return Promise.reject(error);
        }

        if (error.response.status === 403 && !originalRequest._retry) {
            originalRequest._retry = true;
            const refreshToken = loadState().auth.wsseToken.refreshToken;

            //store.dispatch(refreshTokenAction({ _token: refreshToken }));
            console.log('refreshToken: ', refreshToken);
            return axios.post('/api/v1/profile/refresh_token', { _token: refreshToken })
                .then(res => {
                    const now = moment().format('YYYY-MM-DDTHH:mm:ssZ');
                    const then = res.datetime;
                    const timeOffset = moment(now, 'YYYY-MM-DDTHH:mm:ssZ').diff(moment(then, 'YYYY-MM-DDTHH:mm:ssZ')) / 1000;
                    const authData = {
                        ...store.getState().auth,
                        wsseToken: res.content.token,
                        timeOffset
                    };
                    store.dispatch({type: 'auth/SET_AUTH', data: authData});
                    return axios(originalRequest);
                })
        }*/
        return Promise.reject(error);
    }
);

export default axios;
